export default "<!-- Router outlets -->\r\n<router-outlet></router-outlet>"